<template>
  <div class="mt-5" v-if="user">
    <h2>Brukeropplysninger</h2>
    <div class="section">
      <table class="table">
        <tbody>
          <tr>
            <th>Brukernavn</th>
            <td>{{ user.email }}</td>
          </tr>
          <tr>
            <th>Passord</th>
            <td>*******</td>
          </tr>
        </tbody>
      </table>
      <div v-if="changePassword">
        <h5>Bytt passord</h5>
        <div class="row">
          <div class="col-md-6">
            <b-form @submit.prevent="onSubmit" @keydown="errors = {}">
              <b-form-group id="input-group-1" label="Oppgi nåværende passord" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="form.old_password"
                  type="password"
                  required
                  autocomplete="off"
                  :class="{'is-invalid': errors.hasOwnProperty('old_password')}"
                ></b-form-input>
                <b-form-invalid-feedback v-if="errors.hasOwnProperty('old_password')" :state="true">
                  {{errors.old_password[0]}}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group id="input-group-2" label="Oppgi nytt passord" label-for="input-2">
                <b-form-input
                  id="input-2"
                  v-model="form.password"
                  type="password"
                  required
                  autocomplete="off"
                  :class="{'is-invalid': errors.hasOwnProperty('password')}"
                ></b-form-input>
                <b-form-invalid-feedback v-if="errors.hasOwnProperty('password')" :state="true">
                  {{errors.password[0]}}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Oppgi nytt passord igjen"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="form.password_confirmation"
                  type="password"
                  required
                  autocomplete="off"
                  :class="{'is-invalid': errors.hasOwnProperty('password_confirmation')}"
                ></b-form-input>
                <b-form-invalid-feedback v-if="errors.hasOwnProperty('password_confirmation')" :state="true">
                  {{errors.password_confirmation[0]}}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-button type="submit" variant="primary">Lagre nytt passord</b-button>
            </b-form>
          </div>
        </div>
      </div>
      <div v-else>
        <a href="#" @click.prevent="changePassword = !changePassword" class="btn btn-sm btn-primary"
          >Bytt passord</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { account } from '@/api';

export default {
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
  },

  data() {
    return {
      changePassword: false,
      rootUrl: process.env.VUE_APP_API_URL,
      form: {
        old_password: '',
        password: '',
        password_confirmation: ''
      },
      errors: [],
    };
  },

  methods: {
    onSubmit() {
      if (this.form.password !== this.form.password_confirmation) {
        this.$bvToast.toast(`Passorden matcher ikke`, {
          title: 'Nåe gikk feil',
          variant: 'danger'
        })
        return;
      }

      account.update(this.form)
        .then(() => {
          this.form = {
            old_password: '',
            password: '',
            password_confirmation: ''
          };

          this.$bvToast.toast(`Passorded ble byttet`, {
            variant: 'success',
            title: 'Passord byttet',
            autoHideDelay: 5000,
          })
        })
        .catch((error) => this.errors = error.errors)
    }
  },
};
</script>

<style scoped>
th {
  width: 50%;
}
</style>
